var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404PageLayoutDesktopLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 158,
    viewBox: "0 0 1440 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1440.29 82.6668V147.396L0.289062 147.396V79.5473L8.68762 76.529C107.017 41.1917 213.861 37.0872 314.611 64.7769L366.114 78.9315C443.311 100.148 525.419 94.5831 599.048 63.1444C682.285 27.6028 775.972 25.2772 860.87 56.6452L875.988 62.2307C949.208 89.2838 1028.81 94.0167 1104.72 75.831L1274.46 35.1653C1334.24 20.8437 1397.16 38.8658 1440.29 82.6668Z",
    fill: "#231FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1440.29 102.211V147.396L0.289062 147.396V77.9874C39.8344 35.2853 100.777 19.8009 155.91 38.447L225.24 61.8946C284.911 82.0756 349.873 79.9589 408.104 55.9361L425.189 48.8879C489.695 22.2764 561.295 18.2155 628.396 37.3627L764.721 76.2622C844.426 99.0059 929.655 92.3003 1004.82 57.3716C1084.16 20.5066 1174.53 15.1497 1257.67 42.3846L1440.29 102.211Z",
    fill: "#231FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 127.948L0 173.133L1440.29 173.133V135.612C1359.35 88.9782 1263.4 75.8029 1172.9 98.8947L1129.1 110.069C1059.89 127.727 986.644 120.015 922.631 88.3323C851.731 53.2405 769.81 47.6893 694.824 72.8954L624.682 96.4731C553.548 120.384 476.433 119.638 405.775 94.3546C348.238 73.7664 286.155 69.361 226.288 81.6181L0 127.948Z",
    fill: "#231FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404PageLayoutDesktopLight);
export default __webpack_public_path__ + "static/media/404-page-layout-desktop-light.c5c62c64e1c3c7d5b09dd411cf726713.svg";
export { ForwardRef as ReactComponent };